import { render, staticRenderFns } from "./PaginationPage.vue?vue&type=template&id=2676b85a&scoped=true&"
import script from "./PaginationPage.vue?vue&type=script&lang=js&"
export * from "./PaginationPage.vue?vue&type=script&lang=js&"
import style0 from "./PaginationPage.vue?vue&type=style&index=0&id=2676b85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2676b85a",
  null
  
)

export default component.exports